<template>
  <v-form
    ref="Documents">
    <div
      class="d-flex justify-center"
      style="width: 100%;"
      v-if="loadingDocuments">
      <v-progress-circular
        :color="defaultColor"
        indeterminate
        size="120"
      />
    </div>

    <span
      v-if="localDocuments && localDocuments.length > 0"
      class="primary--text font-weight-regular"
      style="font-size: 18px;">
      {{
        localDocuments.length > 1
          ? 'Upload dos arquivos'
          : 'Upload do arquivo'
      }}
    </span>

    <div
      v-for="(document, documentIndex) in localDocuments"
      :key="documentIndex">
      <div
        class="d-flex flex-column">
        <span
          class="foreground--text pt-3"
          style="font-size: 16px;">
          {{ document.name }}
          <b>{{ document.mandatory ? '*' : '' }}</b>
        </span>

        <FileUploader
          ref="FileUploader"
          defaultColor="primary"
          :file="document.file"
          :accept="acceptTypes"
          :rules="document.mandatory
            ? [rule.fileRequired, rule.fileSizeValidation, ruleFileTypes]
            : document.file ? [rule.fileSizeValidation, ruleFileTypes] : []"
          :fileLoaded="document.fileLoaded"
          @loadedFinished="document.fileLoaded = false"
          @isLoadingFile="$emit('isLoadingFile', $event)"
          @setFile="setFile(document, $event)"
          @clean="cleanFile(document)"
        />
      </div>
    </div>
  </v-form>
</template>

<script>
import MovementDocumentService from '@/services-http/sdi/MovementDocumentService';
import FileUploader from '@/components/FileUploader/FileUploader.vue';
import MajorityMixin from '@/shared/mixins/majority/majorityMixin';
import DocumentService from '@/services-http/sdi/DocumentService';
import BenefitService from '@/services-http/odoo/BenefitService';
import Rules from '@/shared/validators/formRules';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: "Documents",

  components: {
    FileUploader,
  },

  data: () => ({
    documentService: null,
    localDocuments: [],
    benefitTypes: [],
    rule: null,
    loadingDocuments: false,
    acceptTypes: '.xls,.xlsx,.csv,.txt,.pdf',
  }),

  mixins: [
    MajorityMixin,
  ],

  props: {
    defaultColor: {
      type: String,
      default: 'primary',
    }
  },

  watch: {
    show: {
      immediate: true,
      handler(showRequestModal) {
        if (showRequestModal) {
          this.fetchDocuments();

          return;
        }

        this.localDocuments = [];
      }
    },
  },

  methods: {
    ...mapMutations({
      setRequestForm: 'majority/setRequestForm',
      loadingPage: 'majority/loadingPage',
    }),

    filesValidation() {
      let fieldsValidateds = true;

      this.$refs.Documents.$children.forEach((field) => {
        const fileUploadRef = field.$refs.FileUploader;

        if (!fileUploadRef.validate()) {
          fieldsValidateds = false;
        }
      });

      return fieldsValidateds;
    },

    cleanFile(document) {
      document.file = null
    },

    async loadBenetiType() {
      const benefitService = new BenefitService();

      await benefitService.FindAll()
        .then((response) => {
          if (response && response.data && response.data.records.length) {
            this.benefitTypes = response.data.records.filter(
              (benefit) => benefit.xipp_contract_record_type_code !== null);
          }
        })
        .catch((error) => this.showMessageError(`Ocorreu um erro durante o carregamento dos tipos de Benefício.`))
        .finally(() => this.loadingDocuments = false);
    },

    async fetchDocuments() {
      const movementDocumentService = new MovementDocumentService();

      this.loadingDocuments = true;

      if (
        !this.benefitTypes ||
        (Array.isArray(this.benefitTypes) && this.benefitTypes.length === 0)
      ) {
        await this.loadBenetiType();
      }

      const benefitType = this.benefitTypes.find(
        (benefit) => benefit.name === this.beneficiary.benefitType);

      const params = new URLSearchParams({
        isMajority: true,
        beneficiaryType: 'DEPENDENT',
        movementType: this.majorityStatus === 'COVERAGE' ? 'UPDATE_DEPENDENT' : 'DELETE_DEPENDENT',
        insuranceCarrierId: this.beneficiary.carrierId,
        parentContractId: this.beneficiary.contractId,
        benefitType: benefitType ? benefitType.default_code : null,
        kinshipId: this.beneficiary.kinshipId,
      });

      await movementDocumentService.FindEnabled(params)
        .then((response) => response.data)
        .then((result) => result.map((document) => ({
            ...document,
            fileLoaded: false,
          })))
        .then((documents) => {
          this.localDocuments = documents;

          this.$emit('documentsLoaded');
          })
        .catch((error) => this.showMessageError(`Ocorreu um erro durante o carregamento dos arquivos.`))
        .finally(() => this.loadingDocuments = false);
    },

    async setFile(document, file) {
      document.file = file;

      await this.uploadDocument(document);
    },

    async uploadDocument(document) {
      this.loadingPage(true);

      const { documentTypeId, file } = document;

      await this.documentService.UploadDocument(documentTypeId, file)
        .then((response) => response.data)
        .then((documentId) => document.id = documentId)
        .then(() => {
          const documentIds = this.localDocuments
            .filter((doc) => doc.file)
            .map((item) => item.id);

          this.setRequestForm({documents: documentIds})

          this.loadingPage(false);
          document.fileLoaded = true;
        })
        .catch((err) => {
          document.fileLoaded = true;
          this.$set(document, 'file', null)

          this.showMessageError(
            `Ocorreu um erro durante o upload do arquivo.`
          );

          this.loadingPage(false);
        });
    },

    showMessageError(message) {
      const majoritySnackbar = this.majorityViewReference()?.$refs.MajoritySnackbar || false;

      majoritySnackbar.open(
        'error',
        message
      );
    }
  },

  computed: {
    ...mapGetters({
      majorityStatus: 'majority/majorityStatus',
      requestForm: 'majority/requestForm',
      beneficiary: 'majority/beneficiary',
      show: 'majority/showModal',
    }),

    ruleFileTypes() {
      return this.rule.fileTypeValidation(this.acceptTypes);
    },
  },

  created() {
    this.documentService = new DocumentService();
    this.rule = new Rules();
  },

  async mounted() {
    await this.loadBenetiType();
  }
}
</script>